import axiosPost from "./axiosPost";

export const RNESArticulosGet = async (credentials, data) => {
    const body = {
        service: "RNESArticuloGet",
        params: {
            rnesRubroId: data?.rubroId || null,
            rnesArticuloId: data?.articuloId || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
